import $api from "../../../http/game";
import {AxiosResponse} from "axios";
export default class SimpleRouleteService {
    static create_bet(amount,choice,typeBet="real"){
        return $api.post("/ApiWheel/bet_game", {amount,choice,typeBet})
    }
    static delete_bet(id){
        return $api.delete("/ApiWheel/deleteBet/"+id)
    }
    static enter_game(){
        return $api.get("/ApiWheel/enter_game")
    }

}